<form [formGroup]="form">
  <div class="notification-setup" [class.white]="color == 'white'">
    <app-checkbox-input
      *ngFor="let type of ['mobile', 'email']"
      [formControlName]="type"
      [labelKey]="'newsNtfTypeAlt.' + type | toLL: 'capitalize'"
      appearance="outline"
      [color]="color == 'primary' ? 'primary' : 'accent'"
      [disabled]="disabled || !$any(enabled)[type]"
    ></app-checkbox-input>
  </div>
  <div *ngIf="form.get('email')?.value && !hideWarning" class="email-warning" [class.primary]="color == 'primary'">
    <b class="warning">{{ 'label.warning' | locUpper }}!</b> {{ 'email.attachmentWarning' | loc }}
  </div>
</form>
<app-input-errors [control]="form"></app-input-errors>
